module.exports = __webpack_public_path__ + "static/media/Anna-signature.9feb4ef8.jpg";